module.exports = __webpack_public_path__ + "img/icon-plus.48f7f012.svg";